import { useEffect, useRef, useState } from "react"
import styled from "styled-components/macro"
import { EffectFade, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"

const Info2Carousel = ({ info1Data }) => {
  const swiperRef = useRef(null)
  const [currentInfoIndex, setCurrentInfoIndex] = useState(0)

  return (
    <Wrapper>
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        effect="fade"
        className="bgImage"
        spaceBetween={0}
        slidesPerView={1}
        centeredSlides={true}
        onSlideChange={(_swiper) => setCurrentInfoIndex(_swiper.activeIndex)}
        fadeEffect={{ crossFade: true }}
        modules={[EffectFade]}
        speed={1000}
        style={{ height: "100%", width: "100%" }}
      >
        {info1Data?.block.map((content, index) => (
          <SwiperSlide
            key={content?.img?.publicURL + index?.toString()}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              style={{
                width: "33.3%",
                height: "100%",
                marginLeft: "auto",
                objectFit: "cover",
              }}
              alt={content?.content?.filename}
              src={content?.img?.publicURL}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="copy">
        <div className="mainText">
          <div className="headline">
            {info1Data?.block[currentInfoIndex]?.headline}
          </div>
          <div className="body">{info1Data?.block[currentInfoIndex]?.body}</div>
        </div>
      </div>
      <div className="bottomBar">
        {info1Data?.block[currentInfoIndex]?.grid?.map((content, index) => (
          <div className="card">
            <div className="title">{content.title}</div>
            <div className="body">{content.body}</div>
          </div>
        ))}
      </div>
    </Wrapper>
  )
}

export default Info2Carousel

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .bgImage {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .copy {
    width: 55%;
    margin-left: 10rem;
    height: 85%;
    padding: 0 5rem;
    display: flex;
    align-items: center;
    color: white;
    z-index: 1;
    pointer-events: none;
    border-left: 1px solid var(--accent);

    .mainText {
      width: 90%;
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .headline {
        font-size: 4rem;
        color: var(--secondary);
        opacity: 0.75;
      }

      .body {
        width: 100%;
        font-size: 1.25rem;
        line-height: 150%;
        color: var(--secondary);
      }
    }
  }

  .bottomBar {
    display: flex;
    width: 100%;
    height: 25%;
    /* box-shadow: inset 0 -200px 100px 10px rgba(0, 0, 0, 0.25); */
    z-index: 1;
    border-top: 1px solid var(--accent);
    align-items: center;

    .card {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      width: 33.3%;
      padding: 0 4rem;
      color: var(--secondary);
      letter-spacing: 1px;

      &:nth-child(3) {
        color: white;
      }

      .title {
        font-size: 1.25rem;
      }

      .body {
        font-size: 1rem;
        line-height: 150%;
      }
    }
  }
`
